module.exports = __webpack_public_path__ + "img/fyt_p1.b9122c79.png";